const bubble6 = (color) =>   `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 453.2 453.2" style="enable-background:new 0 0 453.2 453.2;" xml:space="preserve">
<style type="text/css">
\t.st0{fill:${color};}
</style>
<path class="st0" d="M314.5,230.6v-68.2c0-27.7-21.8-50.2-48.7-50.2H114.3c-26.8,0-48.7,22.5-48.7,50.2v68.2
\tc0,25.2,18.3,46.6,42.5,49.8l6.3,0.8l-22.7,48.6l104.8-49h69.2C292.6,280.8,314.5,258.3,314.5,230.6z M104.2,159.6
\tc-0.1-6.2,4.8-11.2,11-11.4h155.2c6.2,0.1,11.1,5.2,11,11.4l0,0c0.1,6.2-4.8,11.2-11,11.4H115.2C109,170.9,104.1,165.8,104.2,159.6
\tL104.2,159.6z M104.2,197.5c-0.1-6.2,4.8-11.2,11-11.4H230c6.2,0.1,11.1,5.2,11,11.4l0,0c0.1,6.2-4.8,11.2-11,11.4H115.2
\tC109,208.7,104.1,203.7,104.2,197.5L104.2,197.5z M114.3,247.6c-6.3-0.3-11.1-5.6-10.9-11.8c0.2-5.9,5-10.6,10.9-10.9h155.2
\tc6.3,0.3,11.1,5.6,10.9,11.8c-0.2,5.9-5,10.6-10.9,10.9H114.3z"/>
<path class="st0" d="M226.6,0C101.5,0,0,101.5,0,226.6s101.5,226.6,226.6,226.6s226.6-101.5,226.6-226.6S351.8,0,226.6,0z
\t M198.6,290.2l-126,58.9l28.2-60.5c-25.7-6.4-44.4-30.3-44.4-58v-68.2c0-32.9,26-59.6,57.9-59.6h151.6c31.9,0,57.9,26.8,57.9,59.6
\tv68.2c0,32.9-26,59.6-57.9,59.6L198.6,290.2z M366.8,313.2l15.1,35.8l-68.6-35.5h-40.6c-11.8,0-22.2-7.5-27.6-18.5H275
\tc29.3,0,53.3-24.7,53.3-54.9v-43.5h34.5c17.4,0,31.7,16.2,31.7,36.1v44.8C394.4,295.7,382.2,310.9,366.8,313.2L366.8,313.2z"/>
</svg>
`
export default bubble6;


//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble6.js
// module id = null
// module chunks = 